@if (deviceDetection.isMobile()) {
  <app-unsupported-device></app-unsupported-device>
} @else {
  <div [dir]="languageService.getCurrentLang() === 'ar' ? 'rtl' : 'ltr'">

  <router-outlet></router-outlet>

  </div>
}